export function initFancyBox() {
  const $fancyBox = $('.js-fancybox');
  const fancyBox = $('.fancybox');
  if ($fancyBox.length === 0 && fancyBox.length === 0) {
    return;
  }
  import('fancybox/dist/js/jquery.fancybox.pack.js').then(module => {
    if (fancyBox.length) {
      $('.fancybox').fancybox({
        padding: 0,
        margin: 50,
        autoSize: true,
        maxWidth: 1000,
        maxHeight: 1000,
        prevEffect: 'none',
        nextEffect: 'none',
        helpers: {
          title: {
            type: 'inside', // 'float', 'inside', 'outside' or 'over'
          },
        },
      });
    }
    if ($fancyBox.length) {
      $fancyBox.each((index, element) => {
        const $element = $(element);
        $element.fancybox({
          padding: 0,
          margin: 50,
          autoSize: true,
          maxWidth: 1770,
          maxHeight: 1000,
          prevEffect: 'none',
          nextEffect: 'none',
          wrapCSS: $element.data('fancyboxWrapClass') || '',
          helpers: {
            title: {
              type: 'inside', // 'float', 'inside', 'outside' or 'over'
            },
          },
        });
      });
    }

    const $fancyBoxIframe = $('.js-fancyboxIframe');
    if ($fancyBoxIframe.length) {
      $fancyBoxIframe.each((index, element) => {
        const $element = $(element);
        $element.fancybox({
          padding: 0,
          margin: 0,
          maxWidth: 1170,
          maxHeight: 1170,
          fitToView: true,
          width: '100%',
          height: '100%',
          autoSize: false,
          closeClick: false,
          prevEffect: 'none',
          nextEffect: 'none',
          iframe: {
            scrolling: 'auto',
            preload: false,
          },
          wrapCSS: $element.data('fancyboxWrapClass') || '',
          helpers: {
            title: {
              type: 'inside', // 'float', 'inside', 'outside' or 'over'
            },
          },
        });
      });
    }
  });
}
